/* eslint-disable import/no-cycle */
import SocialEmbed from './SocialEmbed';

export default function initSocialEmbed() {
  document
    .querySelectorAll('.social-embed')
    .forEach(($embed) => new SocialEmbed($embed));
}

initSocialEmbed();
